/** Copyright (C) 2023 Trend Micro Inc. All rights reserved. */

import { useSelector, useDispatch } from 'react-redux'
import type { TypedUseSelectorHook } from 'react-redux'
import { configureStore } from '@reduxjs/toolkit'
import rootReducer from '@redux/reducers'
import api from '@redux/apis/baseApi'
import resetStateMiddleware from '@redux/middlewares/resetStateMiddleware'
import c1StateMiddleware from '@redux/middlewares/c1StateMiddleware'
import { isC1Prod } from '@utils/env'

export const middlewares = [
  c1StateMiddleware,
  resetStateMiddleware,
  api.middleware,
]

export const storeInstance = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(middlewares),
  devTools: !isC1Prod && { name: 'web-app-fss', maxAge: 200 },
})

export type RootState = ReturnType<typeof storeInstance.getState>
export type AppDispatch = typeof storeInstance.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

// The export name has to be `storeInstance` for the C1C shared store to work
export default storeInstance
